import "./RadioButton.scss"

export default function RadioButton({ checked, onClick }) {
  return (
    <div className={`radio-button ${checked ? "radio-active" : ""}`} onClick={onClick}>
      {checked ? <div className="radio-button-selector" /> : ""}
    </div>
  )
}
